import { useTranslation } from '@sib/i18n';
import { FileUploadMode } from '@sib/types';
import {
  cn,
  Dialog,
  DialogContent,
  DialogTitle,
  VisuallyHidden,
} from '@sib/ui';
import { FullScreenDropzoneView } from '../Dropzone/FullScreenDropzoneView';
import { FileManagerContent } from '../FileManager/FileManagerContent';

interface FileDropDialogProps {
  currentMode: FileUploadMode | null;
  onClose: () => void;
  onModeChange: (mode: FileUploadMode) => void;
}

export const FileDropDialog = ({
  currentMode,
  onClose,
  onModeChange,
}: FileDropDialogProps) => {
  const { t } = useTranslation();

  return currentMode ? (
    <Dialog open onOpenChange={isOpen => !isOpen && onClose()}>
      <DialogContent
        className={cn('flex flex-col', {
          'h-[526px] w-[817px] max-w-full items-center justify-center rounded-lg bg-white p-6 text-center':
            currentMode === FileUploadMode.Dropzone,
          'h-[554px] w-[1337px] max-w-full gap-7 p-7 max-lg:h-full max-lg:rounded-none!':
            currentMode === FileUploadMode.FileManager,
        })}
      >
        <VisuallyHidden.Root>
          <DialogTitle>{t('fileManager.drag')}</DialogTitle>
        </VisuallyHidden.Root>
        {currentMode === FileUploadMode.Dropzone && (
          <FullScreenDropzoneView
            onOpenFileManager={() => onModeChange(FileUploadMode.FileManager)}
          />
        )}

        {currentMode === FileUploadMode.FileManager && (
          <FileManagerContent closeDialog={onClose} />
        )}
      </DialogContent>
    </Dialog>
  ) : null;
};
